import uuid from 'react-native-uuid';
import { useQuery } from '@tanstack/react-query';
import get from 'lodash/get';
import { AllSettled, ApiLogger } from 'fmc-digital-common';
import { concat } from 'lodash';
let trackingAPIResponse = [];
const useTrackingItemsQuery = ({
  accessToken,
  selfServUrl,
  xApiKey,
  loanNumber,
  select,
  enabled
}) => {
  const trackingConfig = {
    method: 'get',
    url: `${selfServUrl}/${loanNumber}/documents`,
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'x-api-key': `${xApiKey}`,
      'x-correlation-id': uuid.v4().toString()
    }
  };
  const historyConfig = {
    method: 'get',
    url: `${selfServUrl}/${loanNumber}/documents/history`,
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'x-correlation-id': uuid.v4().toString(),
      'x-api-key': xApiKey
    }
  };
  return useQuery({
    queryKey: ['tracking-items', loanNumber],
    queryFn: () => AllSettled([ApiLogger(trackingConfig), ApiLogger(historyConfig)]),
    enabled: enabled,
    select
  });
};
const transformToSections = data => {
  const [tracking, history] = data;
  const documentsResponseDetails = concat(get(tracking, ['value', 'borrower'], []), get(tracking, ['value', 'loan'], []));
  const historyResponseDetails = get(history, ['value'], []);
  trackingAPIResponse.documentsData = documentsResponseDetails;
  trackingAPIResponse.historyData = historyResponseDetails;
  return trackingAPIResponse;
};
const updateTrackingResponse = (data, itemName) => {
  let response = [];
  const [tracking, history] = data;
  const documentsResponseDetails = get(tracking, ['value', 'responseDetails'], []);
  const updatedData = documentsResponseDetails?.map(item => item.trackingItemName == itemName && ['Outstanding', 'Pre gate Incomplete', 'Pending'].includes(item.status) ? {
    ...item,
    status: 'Borrower Submitted'
  } : item);
  if (tracking) {
    tracking.value.responseDetails = updatedData;
  }
  response.push(tracking, history);
  return response;
};
const useLoanOverviewQuery = ({
  selfServUrl,
  authToken,
  loanNumber,
  xApiKey
}) => {
  const correlationId = uuid.v4().toString();
  const config = {
    method: 'get',
    url: `${selfServUrl}/${loanNumber}`,
    headers: {
      'Authorization': `Bearer ${authToken}`,
      'x-correlation-id': correlationId,
      'x-api-key': xApiKey
    }
  };
  return useQuery({
    queryKey: ['loan-overview', loanNumber],
    queryFn: () => ApiLogger(config),
    select: data => data.loanOverview
  });
};
const Helpers = {
  transformToSections
};
const useStatusTrackerQuery = ({
  selfServUrl,
  xApiKey,
  authToken,
  loanNumber
}) => {
  const correlationId = uuid.v4().toString();
  const config = {
    method: 'get',
    url: `${selfServUrl}/${loanNumber}/status-tracker`,
    headers: {
      'Authorization': `Bearer ${authToken}`,
      'x-correlation-id': correlationId,
      'x-api-key': xApiKey
    }
  };
  return useQuery({
    queryKey: ['status-tracker', loanNumber],
    queryFn: () => ApiLogger(config)
  });
};
export { useTrackingItemsQuery, Helpers, useLoanOverviewQuery, trackingAPIResponse, useStatusTrackerQuery, updateTrackingResponse };
//# sourceMappingURL=TrackingItems.js.map